import axios from "axios";
import { QueryClient } from "react-query";

export const platform = "web";

export const baseUrl = "https://uat.zocket.com/customer";
export const oAuth2RefreshURL = "https://uat.zocket.com/customer/auth/api/v1/refresh";
export const uploadBaseUrl = "https://uat.zocket.com/customer/user/api/v1/common/upload-file";

export const mqttHost = "b-1c26a9c8-572f-46ff-bafd-6e68ff0c5546-1.mq.ap-south-1.amazonaws.com";
export const mqttUsername = "messanger";
export const mqttPassword = "MeS$3nger@12E";

export const amqpHost = "b-619442ce-c58d-4204-8615-170f220c34ec.mq.ap-south-1.amazonaws.com:5671";
export const amqpUsername = "zocket_web_client";
export const amqpPassword = "vrGdkGL8qxXJ5ki";

export const encryptionKey = "60d7ff8c994b72ad87b86685fe3621fa";

export const api = axios.create({
  baseURL: baseUrl,
  headers: {
    Authorization:
      "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2OTQ2ODM3NjE1NjYsImlhdCI6MTY5MjI2NDU2MSwibmJmIjoxNjkyMjY0NTYxLCJzdWIiOjEzMH0.T1DIrcdZSUhd1JjhBuokYPbgwdoJ_i70yVuSybrkcs3cZk14XcoRpRTvGRxexNSIu1CO8D8kikZvdOWf8oAmvBzcSBxVnCvW8Du0mjOA8m_GrwIUpU-ots-pi5qFSrqk5Ku7T2nFZ-xGgvBOrNEOdBSXewkJagXBvMq0_cm0U7I",
  },
});

export const queryClient = new QueryClient();
